export function OnboardingBackground() {
  return <div className='fixed inset-0 -z-10 bg-primary' />;
}
